import Pathes from '@/helpers/pathes';
import axios from '@/axios-api';
import { getQuery } from '@/helpers/utils';

export const brandService = {
  brandDetail: id => axios.get(Pathes.Company.detailById(id)),
  founderDetail: id => axios.get(Pathes.Founders.detail(id)),
  founderFundraisingStatus: founderId =>
    axios.get(Pathes.Founders.fundraisingStatus(founderId)),
  brandDetailBySlug: slug => axios.get(Pathes.Company.detailBySlug(slug)),
  activeBrands: () => axios.get(Pathes.Company.activeBrands),
  inactiveBrands: params =>
    axios.get(Pathes.Company.inactiveBrands + getQuery(params)),
  activeFounders: params =>
    axios.get(Pathes.Founders.activeFounders + getQuery(params)),
  inactiveFounders: params =>
    axios.get(Pathes.Founders.inactiveFounders + getQuery(params)),
};
